// assets/theme-verification.js
class ThemeVerification {
  constructor() {
    this.baseUrl = "https://themihub.com/verify-purchase-token";
    this.isVerified = true; // FORCE VERIFIED TO TRUE
    this.init();
  }

  getStoreUrl() {
    let storeUrl = window.location.hostname;
    if (window.Shopify?.shop) {
      storeUrl = window.Shopify.shop;
    }
    return storeUrl.replace(/^(https?:\/\/)?(www\.)?/, "").replace(/\/$/, "");
  }

  async init() {
    // We disable the popup settings and force verified status
    this.enableRemovePopup = false; 
    this.isVerified = true;

    console.log("Theme Verification Bypassed: Server Offline Mode Active.");
    
    // We do NOT call checkVerification() because the server is down.
    // This prevents the "catch" error from locking the screen.
    this.hideOverlay(); 
  }

  generateUniqueId() {
    return "thv-bypass-" + Math.random().toString(36).substring(2, 9);
  }

  // We keep the function names so the theme doesn't crash, 
  // but we make them do nothing.
  async checkVerification() {
    this.isVerified = true;
    return { verified: true };
  }

  showVerificationOverlay(isRemoval = false) {
    // Function exists but will not execute
    console.log("Verification overlay suppressed.");
    return false;
  }

  initializeFormListeners() {
    return false;
  }

  showMessage() {
    return false;
  }

  hideOverlay() {
    const overlays = document.querySelectorAll('[data-theme-verification="true"]');
    overlays.forEach((overlay) => overlay.remove());
  }

  async verifyPurchase() {
    this.isVerified = true;
    this.hideOverlay();
  }

  async removePurchaseToken() {
    console.log("Token removal disabled in offline mode.");
  }
}

// Initialize immediately
document.addEventListener("DOMContentLoaded", () => {
  window.themeVerification = new ThemeVerification();
});